"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

const PlayButton = ({
  onClick,
  className
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: (0, _classnames.default)('play-button', className),
  onClick: onClick
}, /*#__PURE__*/_react.default.createElement("div", {
  className: "play-button__icon"
}));

PlayButton.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  className: _propTypes.default.string
};
PlayButton.defaultProps = {
  className: ''
};
var _default = PlayButton;
exports.default = _default;